import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { Avatar } from '#/components/Avatar/Avatar';
import { Box } from '#/components/Box/Box';
import { Divider } from '#/components/Divider/Divider';
import { Hide } from '#/components/Hide/Hide';
import { Text } from '#/components/Text/Text';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ApiEvent } from '#/modules/listing/events/api/types/ApiEvent';
import { viewUserProfileRoute } from '#/modules/userProfile/routing/userProfile.routes';
import { colors } from '#/theme/theme';

import { ListingViewSidebarLink } from './ListingViewSidebar.styled';

type Props = {
  creator: NonNullable<ApiEvent['creator']>;
};

export function ListingViewSidebarEventHost(props: Props) {
  const { i18n } = useI18n();

  const { creator } = props;

  const navigate = useNavigate();

  const onClick = useCallback(() => {
    void navigate(
      viewUserProfileRoute.with({
        username: creator.username,
      }),
    );
  }, [creator, navigate]);

  return (
    <Hide xs sm md>
      <Box display="flex" gridGap={3} flexDirection="column">
        <Text color={colors.lightContentGrey}>{i18n('Hosted By')}</Text>

        <Avatar
          border="white"
          image={creator.image}
          name={creator.name}
          size="xs"
          onClick={onClick}
          style={{ cursor: 'pointer' }}
        />

        <ListingViewSidebarLink
          to={viewUserProfileRoute.with({
            username: creator.username,
          })}
        >
          {creator.name}
        </ListingViewSidebarLink>
      </Box>
      <Divider marginTop={24} marginBottom={24} />
    </Hide>
  );
}
